<template>
  <div id="contenedor-tablero-expedientes-main">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'TableroExpedientesMain',
  data() {
    return {};
  },
};
</script>
